import { getFileType } from "@/utils/getFileType"
import { DefaultList } from "@components/default-list"
import { Card, Center, Divider, Group, Stack, Text } from "@mantine/core"
import { IconPhotoOff } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"
import { ResourceImage } from "./ResourceImage"
import { SimpleAttachment } from "@/orval/gen/model"
import { FieldData } from "@/orval/gen/model"
import { FieldData as FieldDataComponent } from "@components/field-data"
import { ScrollContainer } from "@components/scroll-container"
import { useGetResource } from "@/orval/gen/api/resource/resource"

interface ResourceCardProps {
  title: string
  attachments: SimpleAttachment[]
  resourceId: number
  defaultFields: { label: React.ReactNode; value: string }[]
  fieldData: FieldData[] | undefined
}

export function ResourceCard({
  title,
  attachments,
  resourceId,
  defaultFields,
  fieldData = [],
}: ResourceCardProps) {
  const { t } = useTranslation("app_server")
  const { data: resource } = useGetResource(
    { resourceId },
    { query: { initialData: undefined } }
  )
  const image = attachments.find((a) => getFileType(a.fileName) === "image")
  return (
    <Card
      h={500}
      w="100%"
      shadow="md"
      display="flex"
      style={{ flexDirection: "column", overflow: "hidden", minWidth: 0 }}
    >
      <Card.Section>
        {image ? (
          <ResourceImage
            attachmentId={image.attachmentId}
            resourceId={resourceId}
            w="100%"
            h={300}
          />
        ) : (
          <Center h={300} mah={"100%"}>
            <IconPhotoOff color="gray" size={100} />
          </Center>
        )}
      </Card.Section>
      <Text
        fw={"bold"}
        fz={"lg"}
        style={{
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Text>
      <Divider />
      <ScrollContainer h="calc(100% - 300px)" w="100%">
        <Stack>
          {defaultFields
            .filter((f) => !!f.value)
            .map((field, i) => (
              <Group key={i}>
                <Text style={{ opacity: 0.5 }}>{field.label}:</Text>
                <Text>{field.value}</Text>
              </Group>
            ))}
          <DefaultList
            data={fieldData}
            renderItem={({ entity: fieldData }) => (
              <Group>
                <Text style={{ opacity: 0.5 }}>{fieldData.type.name}:</Text>
                <Text>
                  <FieldDataComponent fieldData={fieldData} />
                </Text>
              </Group>
            )}
          ></DefaultList>
        </Stack>
      </ScrollContainer>
    </Card>
  )
}
